import { DimensionDashboard } from '@/pages/products/DimensionDashboard';

export function BrandsPage() {
  return (
    <DimensionDashboard
      eyebrow="Merchandising"
      title="Brands"
      description="Brand-level GMV, units, margin and momentum — narrowed by your taxonomy and store filters."
      groupBy="brand"
      snapshotName="products-brands"
    />
  );
}
